import DOMPurify from 'dompurify';

/**
 * Admin-authored rich text (game rules, help, marketing consent) is rendered with
 * `dangerouslySetInnerHTML`. The API accepts any string, so the HTML must be cleaned here: scripts,
 * event-handler attributes and `javascript:` URLs are removed, while the formatting TipTap produces
 * (headings, lists, links, bold, alignment styles) is kept.
 */
export function sanitizeAuthoredHtml(html: string | null | undefined): string {
  if (!html) return '';
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    ADD_ATTR: ['target', 'rel'],
  });
}
